<template>
  <div class="card mb-4 shadow-sm border-radius-xl">
    <div class="card-header pb-0 bg-transparent border-bottom-0">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="font-weight-bolder mb-0">
            <font-awesome-icon icon="comment-sms" class="text-primary me-2" />
            Gestión de SMS
          </h6>
          <p class="text-sm mb-0">Envío de mensajes y administración de plantillas</p>
        </div>
      </div>
    </div>
    <div class="card-body p-4">
      <Templates />
    </div>
  </div>
</template>

<script>
import Templates from "@/views/sms/Templates.vue";
import {get} from "@/utils/httpRequest";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCommentSms, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCommentSms, faWallet);

export default {
  name: "Index",
  components: {
    Templates,
    FontAwesomeIcon
  },
  data: () => ({
    show_tabs: "tab2",
    balance: null
  }),
  mounted() {
    this.getBalance()
  },
  methods: {
    selectTabs(tab){
      console.log(tab)
      this.show_tabs = tab
    },
    async getBalance(){
      const {data} = await get('sms/get-zadarma-balance')
      this.balance = data.balance ? `${data.balance} ${data.currency}`: "0.00 USD"
    }
  }
}
</script>

<style scoped>

</style>
